module.exports = __webpack_public_path__ + "static/media/learners.25e6160f.png";